import './appPromotion.css'
import {Button} from "../../components/general/input/Button";
import Platform from "../logic/platform/platform";

const AppPromotion = () => {

    const isIosBrowser = Platform.isIosWeb();
    const isAndroidBrowser = Platform.isAndroidWeb();


    if((!isIosBrowser && !isAndroidBrowser) || Platform.isMobile()) {
        return null;
    }

    const handleClick = () => {
        if(isIosBrowser) {
            window.location.href = "https://apps.apple.com/app/id6745939071";
        } else {
            window.location.href = "https://play.google.com/store/apps/details?id=uk.co.suthbros.suthbrosordering";
        }
    }

    return (
        <div className="app-promotion-container">
            <p>Download our new ordering app</p>
            <Button
                className="inactive"
                onClick={handleClick}
            >
                Download
            </Button>
        </div>
    )
}

export default AppPromotion;
